import { render, staticRenderFns } from "./host-ex.vue?vue&type=template&id=c4857e02&scoped=true&"
import script from "./host-ex.vue?vue&type=script&lang=js&"
export * from "./host-ex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4857e02",
  null
  
)

export default component.exports